import angular from 'angular';
import { EventTrackerService } from './EventTrackerService';
import 'components/sharpr/identity/identityModule';

angular
	.module('sh.eventTracker', ['sh.identity', 'sh.api', 'sh.cfg', 'sh.sharprEventTracker'])
	.service('EventTracker', EventTrackerService);
